export default {"src":"/_next/static/media/GallstonesandGallbladderDisease.609e260c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};